<div class="mat-dialog-wrapper">
  <div class="d-flex justify-space-between align-items-center mb-1">
    <h2 mat-dialog-title class="m-0">{{ isEditMode ? 'Edit Rounding Figure' : 'Add Rounding Figure' }}</h2>
    <button
          mat-button
          class="header-text-close d-flex align-items-center"
          disableRipple
          mat-dialog-close
    >
    <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="addRoundingForm">
      <div class="form-field">
        <p>Period <span class="text-red">*</span></p>
        <ng-select class="w-500"
          formControlName="accountingPeriodId"
          [clearable]="true"
          [searchable]="true"
          panelClass="mat-select-position"
          [compareWith]="compareByUuid"
          [class.ng-invalid-border]="
            addRoundingForm.controls.accountingPeriodId.touched &&
            addRoundingForm.controls.accountingPeriodId.invalid
          "
        >
          <ng-option *ngFor="let period of accountingPeriods" [value]="period.id">
            <span title="{{ period.name }}">{{ period.name }}</span>
          </ng-option>
        </ng-select>        
      </div>

      <div class="form-field">
        <p>SOFA Accounts <span class="text-red">*</span></p>
        <ng-select class="w-500"
          formControlName="profitLossAccountId"
          [clearable]="true"
          [searchable]="true"
          panelClass="mat-select-position"
          [compareWith]="compareByUuid"
          [class.ng-invalid-border]="
            addRoundingForm.controls.profitLossAccountId.touched &&
            addRoundingForm.controls.profitLossAccountId.invalid
          "
        >
          <ng-container *ngFor="let group of profitLossAccounts">
            <ng-optgroup [label]="group.groupName">
              <ng-option *ngFor="let item of group.listModels" [value]="item.id">
                <span title="{{ item.name }}">{{ item.name }}</span>
              </ng-option>
            </ng-optgroup>
          </ng-container>
        </ng-select>        
      </div>

      <div class="form-field">
        <p>Balance sheet Accounts <span class="text-red">*</span></p>
        <ng-select class="w-500"
          formControlName="balanceSheetAccountId"
          [clearable]="true"
          [searchable]="true"
          panelClass="mat-select-position"
          [compareWith]="compareByUuid"
          [class.ng-invalid-border]="
            addRoundingForm.controls.balanceSheetAccountId.touched &&
            addRoundingForm.controls.balanceSheetAccountId.invalid
          "
        >
          <ng-container *ngFor="let group of balanceSheetAccounts">
            <ng-optgroup [label]="group.groupName">
              <ng-option *ngFor="let item of group.listModels" [value]="item.id">
                <span title="{{ item.name }}">{{ item.name }}</span>
              </ng-option>
            </ng-optgroup>
          </ng-container>
        </ng-select>        
      </div>

      <div class="form-field">
        <p>Fund <span class="text-red">*</span></p>
        <ng-select class="w-500"
          formControlName="fundId"
          [clearable]="true"
          [searchable]="true"
          panelClass="mat-select-position"
          [compareWith]="compareByUuid"
          [class.ng-invalid-border]="
            addRoundingForm.controls.fundId.touched &&
            addRoundingForm.controls.fundId.invalid
          "
        >
          <ng-option *ngFor="let fund of fundList" [value]="fund.id">
            <span title="{{ fund.name }}">{{ fund.name }}</span>
          </ng-option>
        </ng-select>        
      </div>
    </form>
  </mat-dialog-content>
  <div class="d-flex pb-5 pt-10 hr-top pt-1 mt-5">
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="onSave()"
      >
        Save
      </button>
      <button
        class="action-button secondary-button"
        disableRipple
        type="button"
        mat-button
        disableRipple
        (click)="onCancel()"
      >
        Cancel
      </button>
  </div>
</div>
